export default "__VITE_ASSET__DCsVhafK__"